

























































import Vue from 'vue';
import BoxContainer from "@/components/BoxContainer.vue";
import {ExtensionViewModel} from "@/models/ExtensionViewModel";

export default Vue.extend( {
  name: "ExtensionApplicantDetailsPanel",
  components: {
    BoxContainer
  },
  props: {
    extension: {
      type: Object as () => ExtensionViewModel,
    }
  }
} )
